import React from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import Footer from '../Footer/Footer';
import './Terms.scss';

export default function Terms() {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="terms"
    >
      <Helmet>
        <title>Terms and Conditions - DuskBreakers</title>
        <meta name="description" content="DuskBreakers NFT License Terms" />
      </Helmet>
      <section>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="mb-5">DuskBreakers NFT License Terms (v.1.0)</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <p>
                These DuskBreakers NFT License Terms (these <u>&ldquo;Terms&rdquo;</u>&nbsp;) set
                forth the terms and conditions for certain rights granted by Metatheory Inc., a
                Delaware corporation (<u>&ldquo;Metatheory&rdquo;</u>&nbsp;) to the individual owner
                (<u>&ldquo;NFT Owner&rdquo;</u>&nbsp;) of the NFT (as defined below), and certain
                related obligations of NFT Owner. &nbsp;Each of Metatheory or NFT Owner may also be
                referenced as a <u>&ldquo;Party&rdquo;</u>&nbsp; or together as the{' '}
                <u>&ldquo;Parties&rdquo;</u>&nbsp; herein. &nbsp;
              </p>
              <p>
                THESE TERMS CREATE A BINDING LEGAL AGREEMENT BETWEEN NFT OWNER AND METATHEORY, AND
                INCLUDE AN ARBITRATION CLAUSE UNDER WHICH CERTAIN CLAIMS MAY NOT BE BROUGHT IN COURT
                OR DECIDED BY A JURY. PLEASE READ THIS AGREEMENT CAREFULLY.
              </p>

              <ol className="numeric-decimals">
                <li>
                  <p>
                    <strong>Definitions.</strong>
                  </p>
                  <ol>
                    <li>
                      <p>
                        <u>&ldquo;Commercial Use&rdquo;</u>&nbsp; means any revenue-generating or
                        other commercial use.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Covered Works&rdquo;</u>&nbsp; means the NFT Art and any
                        modification or derivative work thereof, in any medium, whether or not
                        considered a &ldquo;derivative work&rdquo; under the U.S. Copyright Act, 17
                        U.S.C. &sect; 101, in each case created by or on behalf of NFT Owner
                        hereunder.&nbsp;
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;License Term&rdquo;</u>&nbsp; means the period of time during
                        which NFT Owner is the exclusive, lawful owner of the NFT, and such
                        ownership is recorded on the applicable blockchain.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;NFT&rdquo;</u>&nbsp; means an identifiable, non-fungible,
                        non-replicable, transferable, cryptographic token on the Ethereum blockchain
                        or another blockchain approved by Metatheory, including those that conform
                        to the ERC-721 standard, which token is governed by these Terms as specified
                        by Metatheory from time to time (which Metatheory may do by providing notice
                        in a public manner, such as on its website or social media accounts
                        associated with the NFT or NFT Art, or with any related Metatheory work,
                        product, service or other offering).
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;NFT Art&rdquo;</u>&nbsp; means the pictorial, graphic,
                        audiovisual, or other artwork that is specifically linked with the NFT when
                        initially issued or minted by or on behalf of Metatheory.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <strong>Copyright License to NFT Art.</strong>
                  </p>
                  <ol>
                    <li>
                      <p>
                        <u>&ldquo;License Grant.&rdquo;</u>&nbsp; Subject to the terms and
                        conditions herein, Metatheory hereby grants to NFT Owner a limited,
                        revocable, non-exclusive, non-transferable, worldwide, royalty-free license,
                        under Metatheory&rsquo;s copyrights in the NFT Art, solely to do the
                        following during the License Term: (a) create modifications or derivative
                        works of the NFT Art to create Covered Works; (b) reproduce, distribute and
                        display Covered Works for NFT Owner&rsquo;s personal, non-commercial use;
                        and (c) reproduce, distribute and display Covered Works for NFT
                        Owner&rsquo;s Commercial Use, up to a total aggregate value of $100,000 (one
                        hundred thousand US Dollars) for such Commercial Use. &nbsp;The above
                        license is sublicenseable only to NFT Owner&rsquo;s service providers to
                        exercise such rights for the benefit of and on behalf of NFT Owner; provided
                        that, all acts and omissions of such providers or of any third party acting
                        on NFT Owner&rsquo;s behalf otherwise with respect to Covered Works will be
                        deemed to be acts and omissions of NFT Owner for purpose of these Terms, and
                        NFT Owner will be responsible therefor. &nbsp; &nbsp;&nbsp;
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;License Exclusions.&rdquo;</u>&nbsp; NFT Owner shall not do
                        (directly or via any third party acting on NFT Owner&rsquo;s behalf) or
                        permit any third party to do any of the following: (a) create or use any
                        Covered Work in any way outside the scope of license expressly granted in
                        Section 2.1 above; (b) create or use any Covered Work in any way that would
                        violate any law or rights of any entity or person; (c) create or use any
                        Covered Work that is (including use in a manner that is) libelous, vulgar,
                        defamatory, threatening, harassing, ethnically or racially offensive,
                        otherwise offensive, harmful, abusive, scandalous, obscene, pornographic or
                        unlawful or encourages a criminal offense; (d) use any Covered Work, alone
                        or in combination with other material, as a trademark, logo, or other
                        indictor of source, except that NFT Owner may use the Covered Work, alone or
                        in combination with other material of NFT Owner, as an avatar or profile
                        picture in connection with NFT Owner&rsquo;s personal social media presence;
                        (e) create or use any Covered Work that contains, or use any Covered Work
                        together with or in close proximity to, any trademark, logo, or other source
                        indicator of Metatheory or any third party; or (f) create or use any Covered
                        Work in any way that is expressly or implicitly disparaging or otherwise
                        harmful to Metatheory, any of its licensors or affiliates, or any of its or
                        their works, products, services or other offerings.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Reservation of Rights.&rdquo;</u>&nbsp; Except for the license to
                        copyrights expressly granted in Section 2.1 above, Metatheory or its
                        licensors retain all right, title, and interest in and to such copyrights,
                        and NFT Owner will have no other right, title or interest therein or in or
                        to any other intellectual property of Metatheory or its licensors, whether
                        express or implied. The NFT Art is, and will continue to be, in its
                        entirety, the sole property of Metatheory or its licensors, as applicable.
                        &nbsp;Without limiting the above, NFT Owner receives hereunder no license or
                        other right to use any trademark, logo, or other source indicator of
                        Metatheory or its licensors.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Covered Works.&rdquo;</u>&nbsp; NFT Owner retains its own right,
                        title and interest in any Covered Works created by or on behalf of NFT Owner
                        hereunder, subject to the rights granted to Metatheory in the Covered Works
                        below and to Metatheory&rsquo;s or its licensors&rsquo; right, title and
                        interest in the underlying NFT Art. NFT Owner hereby grants and agrees to
                        grant to Metatheory an irrevocable, perpetual, non-exclusive, worldwide,
                        royalty-free, fully-paid, transferable license, with the right to sublicense
                        through multiple tiers, to use, reproduce, display, create modifications or
                        derivative works of, distribute, and otherwise exploit in any manner, the
                        Covered Works and Feedback (as defined below). &nbsp;To the extent
                        reasonably necessary to effect or support the license granted by NFT Owner
                        above, NFT Owner hereby waives and agrees to waive (or if not waivable,
                        agree not to assert) any rights of privacy or publicity, or any moral rights
                        or other similar rights, with respect to Covered Works or Feedback. &nbsp;As
                        used above, &ldquo;Feedback&rdquo; means any comments, feedback,
                        suggestions, ideas, or other submissions by NFT Owner to Metatheory
                        regarding the NFT or NFT Art, or any related work, product, service or other
                        offering of Metatheory.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <strong>Termination.</strong>
                  </p>
                  <ol>
                    <li>
                      <p>
                        <u>&ldquo;Termination.&rdquo;</u>&nbsp; The License Term will continue
                        indefinitely until terminated automatically (a) if NFT Owner is no longer
                        the exclusive, lawful owner of the NFT, or (b) upon any breach by NFT Owner
                        of these Terms.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Effect of Termination.&rdquo;</u>&nbsp; Upon termination of the
                        License Term for any reason: (a) the license granted to NFT Owner in Section
                        2.1 above (including any sublicenses granted by NFT Owner) will terminate;
                        (b) NFT Owner will cease all creation, reproduction, distribution, display
                        or other use of Covered Works, and promptly destroy all Covered Works within
                        its control; and (c) any NFT Owner obligations which have previously accrued
                        hereunder, as well as the following provisions (and any other provisions
                        which should reasonably survive) will survive: 1 (Definitions), 2.2 (License
                        Exclusions), 2.3 (Reservation of Rights), 2.4 (Covered Works), 3.2 (Effect
                        of Termination), 4 (Disclaimer and Limitations of Liability) and 5
                        (Miscellaneous). &nbsp;
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <strong>Disclaimer and Limitations of Liability.</strong>
                  </p>
                  <ol>
                    <li className="text-uppercase">
                      <p>
                        <u>&ldquo;Disclaimer.&rdquo;</u>&nbsp; The NFT Art is licensed to NFT Owner
                        hereunder &ldquo;AS-IS,&rdquo; with all faults. &nbsp;Metatheory hereby
                        disclaims all representations and warranties of any kind relating to the
                        NFT, the NFT Art or these Terms (whether express, implied, statutory or
                        arising by custom, trade usage or course of dealings), including any implied
                        warranties of title, noninfringement, merchantability, or fitness for
                        purpose. NFT Owner acknowledges and agrees that: (A) the NFT is not a
                        security for purposes of U.S. federal or state law and (I) does not entitle
                        NFT Owner to participate in the management of Metatheory or to receive any
                        profits from the operations of Metatheory and (II) does not include any
                        voting or other similar rights; (B) to the extent there is a price or market
                        for blockchain assets, such markets and prices are extremely volatile, and
                        variations in the price of other digital assets could materially and
                        adversely affect the value of any digital asset(s) owned by NFT Owner, such
                        as the NFT, and there is no guarantee that the NFT will have or retain any
                        value; (C) there are risks associated with using Internet-native assets
                        (non-fungible tokens, cryptocurrencies, etc.), including the risk of
                        hardware, software or Internet connection failures, the risk of malicious
                        software introduction, and the risk that third parties may obtain
                        unauthorized access to information stored within NFT Owner&rsquo;s digital
                        &ldquo;wallet&rdquo;, and Metatheory will not be responsible for any of the
                        foregoing, however caused; (D) Metatheory does not make any promises or
                        guarantees about the availability of the NFT Art on the Internet or that it
                        will host the NFT Art at any specific location or for any specific period of
                        time; (E) upgrades to the Ethereum blockchain, a fork in the Ethereum
                        blockchain, a failure or cessation of Ethereum, or a change in how
                        transactions are confirmed on the Ethereum blockchain may have unintended
                        adverse effects on all related blockchains using such technologies, and on
                        the NFT; and (F) Metatheory is not responsible for any transaction between
                        NFT Owner and a third party (e.g., NFT Owner&rsquo;s purchase or sale of the
                        NFT from a third party on the so-called &ldquo;secondary market&rdquo;) or
                        for any consequences of such transaction (e.g., any costs or taxes being due
                        with respect to such transaction), and Metatheory shall have no liability in
                        connection with any such transaction or its consequences.
                      </p>
                    </li>
                    <li className="text-uppercase">
                      <p>
                        <u>&ldquo;Limitations of Liability.&rdquo;</u>&nbsp; Neither Metatheory nor
                        its licensors shall be liable for any indirect, incidental, punitive,
                        consequential or special damages, including lost profits or revenue, arising
                        from or relating to the NFT, the NFT Art or these Terms under any theory of
                        liability (including negligence or other tort, contract, or any other
                        theory), even if advised of the possibility of such damages in advance.
                        &nbsp;To the extent permitted by applicable law, Metatheory&rsquo;s maximum
                        aggregate liability to NFT Owner for any damages arising from or relating to
                        the NFT, the NFT Art or these Terms under any theory of liability (including
                        negligence or other tort, contract, or any other theory), shall be limited
                        to the greater of (a) the amount initially paid by NFT Owner to Metatheory
                        for the NFT (if acquired from Metatheory during the initial mint), which in
                        Metatheory&rsquo;s discretion may be satisfied via return in whole or part
                        of consideration so paid by NFT Owner or (b) $100 (one hundred US dollars).
                        &nbsp; Some jurisdictions do not allow the limitation or exclusion of
                        warranties or of liability for certain types of damages, so some of the
                        above limitations or exclusions may not apply to NFT Owner.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <strong>Miscellaneous.</strong>
                  </p>
                  <ol>
                    <li>
                      <p>
                        <u>&ldquo;Modification of Terms.&rdquo;</u>&nbsp; Metatheory may from time
                        to time amend these Terms prospectively. &nbsp;If it does so, it will
                        provide notice in a public manner, such as on its website or social media
                        accounts associated with the NFT or NFT Art, or with any related Metatheory
                        work, product, service or other offering. &nbsp;NFT Owner agrees that its
                        continued creation, reproduction, distribution, display or other use of any
                        Covered Works constitutes its agreement to the amended Terms. &nbsp;If NFT
                        Owner does not agree to any amended Terms that Metatheory publishes, NFT
                        Owner must cease creating, reproducing, distributing, displaying or
                        otherwise using Covered Works. &nbsp;Except as set forth above in this
                        paragraph, these Terms may be amended or modified only by an express writing
                        signed by Metatheory.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Injunctive Relief.&rdquo;</u>&nbsp; NFT Owner acknowledges that
                        its breach of these Terms would cause substantial harm to Metatheory that
                        could not be remedied by payment of damages alone. &nbsp;Accordingly,
                        Metatheory will be entitled to seek preliminary and permanent injunctive
                        relief, and other equitable relief, for any such breach, without any
                        requirement to prove damages or post bond.
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Compliance with Laws.&rdquo;</u>&nbsp; NFT Owner agrees to comply
                        with all laws, rules and regulations applicable to its creation,
                        reproduction, distribution, display or other use of Covered Works, or to its
                        activities with respect to the NFT. &nbsp;
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Indemnification.&rdquo;</u>&nbsp; NFT Owner will indemnify and
                        hold harmless Metatheory, its affiliates and licensors, and its and their
                        respective officers, directors, employees and agents, against any and all
                        claims, actions, proceedings, suits, liabilities, losses, damages, costs and
                        expenses, including reasonable attorneys&rsquo; fees, arising from or
                        relating to any third party claim relating to NFT Owner&rsquo;s creation,
                        reproduction, distribution, display or other use of the Covered Works or
                        other activities under these Terms or with respect to the NFT (except in
                        each case to the extent caused by Metatheory&rsquo;s gross negligence or
                        willful misconduct). &nbsp;Metatheory reserves the right to assume control
                        of the defense and settlement of any such claim, action, proceeding or suit,
                        and NFT Owner will reasonably cooperate with Metatheory with respect
                        thereto.&nbsp;
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Assignment.&rdquo;</u>&nbsp; NFT Owner may not assign or otherwise
                        transfer these Terms or any of its rights hereunder, or delegate any of its
                        obligations hereunder, without the prior written consent of Metatheory in
                        its sole discretion. &nbsp;For clarity, in the event NFT Owner transfers the
                        NFT to a third party, such third party will receive its own license (if any)
                        pursuant to the license terms applicable to the NFT at such time (as
                        specified by Metatheory), and NFT Owner will not transfer these Terms or its
                        rights hereunder to such third party. &nbsp;Any purported assignment or
                        delegation by NFT Owner without such consent will be null and void.
                        &nbsp;Metatheory may freely assign, transfer or delegate these Terms, in
                        whole or in part, from time-to-time. &nbsp;These Terms will be binding upon
                        and inure to the benefit of the Parties&rsquo; successors and permitted
                        assigns. &nbsp;
                      </p>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Dispute Resolution.&rdquo;</u>&nbsp;
                      </p>
                      <ol>
                        <li>
                          <p>
                            <i>Applicable Law.</i>&nbsp; NFT Owner and Metatheory each agree that
                            any dispute arising out of &nbsp;or relating to these Terms, including
                            the interpretation, validity, performance, or breach thereof, or the use
                            of the NFT or NFT Art (a &ldquo;Dispute&rdquo;), will be governed by the
                            substantive laws of the State of Delaware, U.S.A., without regard to its
                            or any other jurisdiction&rsquo;s conflicts of laws principles that
                            would apply another law. &nbsp;Any action or proceeding by NFT Owner
                            relating to any claim arising from or relating to these Terms, the NFT
                            or the NFT Art must commence within the shorter of the applicable
                            statute of limitations or one year after the cause of action has
                            accrued. &nbsp;The United Nations Convention for the International Sale
                            of Goods is hereby disclaimed. &nbsp;
                          </p>
                        </li>
                        <li>
                          <p>
                            <i>Arbitration.</i>&nbsp;
                          </p>
                          <ol>
                            <li>
                              <p>
                                Any Dispute shall be resolved exclusively in the matter set forth
                                herein. &nbsp;
                              </p>
                            </li>
                            <li>
                              <p>
                                A Party shall first give written notice to the other Party of the
                                Dispute and the amount of any claim. &nbsp;The Parties shall then
                                meet in person or by videoconference within sixty (60) days to
                                attempt to resolve the Dispute. Except as necessary to avoid
                                irreparable harm or the expiration of a pertinent statute of
                                limitations, no arbitral or judicial proceeding shall be commenced
                                until such meeting has been had or refused by the opposing Party.
                              </p>
                            </li>
                            <li>
                              <p>
                                Any Dispute not amicably resolved shall be resolved exclusively by
                                binding arbitration administered by the American Arbitration
                                Association (AAA) under the United States Federal Arbitration Act.
                              </p>
                            </li>
                            <li>
                              <p>
                                &nbsp;The arbitration shall be conducted by a single arbitrator
                                under the Commercial Rules, or, if required by the AAA, the Consumer
                                Rules. &nbsp;To review the rules and for further information on the
                                arbitration process, visit www.adr.org.
                              </p>
                            </li>
                            <li>
                              <p>
                                The place of the arbitration shall be Wilmington, Delaware, U.S.A.,
                                but hearings may be held by videoconference or in such other places
                                as the Parties may agree or as the arbitrator may order.
                              </p>
                            </li>
                            <li>
                              <p>
                                In the event that the AAA is unable or unwilling to administer the
                                arbitration, a substitute arbitrator shall be ordered by the court.
                              </p>
                            </li>
                            <li>
                              <p>
                                At any time before the entry of a final judgment from which no
                                further appeal may be taken, Metatheory may require the other Party
                                to participate in person in non-binding mediation, the
                                administrative cost and mediator compensation of which shall be
                                borne solely by Metatheory.
                              </p>
                            </li>
                            <li>
                              <p>
                                The right and obligation to arbitrate under this Section 5.6(b)
                                shall extend to any claim by or against a parent, subsidiary,
                                affiliate, agent, officer, director, contractor, or employee of a
                                Party.
                              </p>
                            </li>
                            <li>
                              <p>
                                Absent Metatheory&rsquo;s written consent, the arbitrator shall have
                                no authority to conduct proceedings on a class or consolidated
                                basis. &nbsp;Provided, however, that in the event that Metatheory is
                                the subject of twenty five (25) or more substantially similar
                                arbitration claims, Metatheory may in its sole discretion request
                                the appointment of a special arbitrator to determine whether issues
                                of law and/or fact common to individually filed claims should be
                                decided on a consolidated basis.
                              </p>
                            </li>
                            <li>
                              <p>
                                Except as necessary to vacate or confirm any arbitral award, or
                                otherwise as required by the law, the existence of and evidence in
                                the arbitration shall be strictly confidential, unless already known
                                to the disclosing Party or in the public domain without fault of the
                                disclosing Party.&nbsp;
                              </p>
                            </li>
                            <li>
                              <p>
                                The prevailing Party shall be entitled to an award of all costs,
                                expenses, and attorneys&rsquo; fees reasonably incurred in the
                                successful prosecution or defense of any claim. In the event that a
                                claimant shall recover less than the highest written offer made
                                before the filing of a demand for arbitration, the respondent shall
                                be deemed to be the prevailing party for purposes of this subsection
                                (xi).
                              </p>
                            </li>
                            <li>
                              <p>
                                Without derogation of the obligation to arbitrate, any judicial
                                proceeding in respect of a Dispute shall be conducted exclusively in
                                the state or federal courts in or for New Castle County, Delaware,
                                U.S.A., except that any judgment thereof or any arbitral award may
                                be enforced in any court of competent jurisdiction. THE PARTIES
                                IRREVOCABLY WAIVE ANY RIGHT TO TRIAL BY A JURY.&nbsp;
                              </p>
                            </li>
                            <li>
                              <p>
                                If any part of this Section 5.6 (b) is deemed invalid as a matter of
                                law, then it shall be severed and the remaining portions of this
                                section shall remain in effect
                              </p>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <u>&ldquo;Other.&rdquo;</u>&nbsp; Headings are provided for convenience only
                        and will not be used to interpret the substance of these Terms. &nbsp;Unless
                        the intent is expressly otherwise in specific cases, the use of
                        &ldquo;include,&rdquo;&nbsp; &ldquo;includes&rdquo;&nbsp; or
                        &ldquo;including&rdquo;&nbsp; herein will not be limiting and
                        &ldquo;or&rdquo;&nbsp; will not be exclusive. &nbsp;These Terms set forth
                        the entire understanding between the Parties with respect to the subject
                        matter hereof, and supersede all prior writings, discussions and
                        understandings, expressed or implied, between the Parties concerning such
                        subject matter. &nbsp;No waiver of any breach of any provision herein will
                        constitute a waiver of any prior, concurrent or subsequent breach of the
                        same or any other provision, and no waiver will be binding unless made in an
                        express writing signed by the waiving Party. &nbsp;In the event that any
                        provision of these Terms is held to be void or unenforceable, the remainder
                        of these Terms shall continue in force, and the severed provision shall be
                        replaced by an enforceable provision most closely reflecting the intention
                        of Metatheory. &nbsp;
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </m.main>
  );
}
